import script from "./QihouYj.vue?vue&type=script&setup=true&lang=js"
export * from "./QihouYj.vue?vue&type=script&setup=true&lang=js"

import "./QihouYj.vue?vue&type=style&index=0&id=20dc69a3&lang=less&scoped=true"
script.__scopeId = "data-v-20dc69a3"

export default script